<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><div class="k-page-wrapper">
	<h1 class="k-page-title d-flex align-center">
		<k-btn icon color="primary" class="mr-2" accessible-label="Return to admin main" @click="return_to_admin_main"><k-icon large>fas fa-school</k-icon></k-btn>
		<div class="ml-2" style="margin-top:3px">{{site_config.subdomain_admin_title}}</div>
		<k-spacer/>

		<k-btn-toggle dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" mandatory
			v-if="both_modes_enabled"
			v-model="mode"
		>
			<k-btn small light :value="'agencies'">Agencies</k-btn>
			<k-btn small light :value="'lti'">  LTI Config  </k-btn>
		</k-btn-toggle>
	</h1>

	<div v-show="mode=='agencies'">
		<div class="d-flex align-center mb-3">
			<h3>Agencies</h3>
			<k-spacer/>
			<div><k-btn @click="load_agency_list">Load / Reload Agencies</k-btn></div>
		</div>

		<div v-if="agencies" style="clear:both">
			<div class="py-4 d-flex">
				<k-text-field
					v-model="agency_search"
					prepend-inner-icon="fa fa-search" clearable clear-icon="fa fa-times-circle"
					prepend-decorative
					aria-label="Search agencies"
					label="Search" single-line hide-details outlined dense background-color="#fff" style="flex:0 1 450px"
				></k-text-field>
			</div>

			<k-data-table light
				:headers="agency_headers"
				:items="agencies"
				xsort-by="['su','user']"
				xsort-desc="[true,false]"
				xmust-sort="true"
				:custom-filter="table_agency_search_filter"
				:search="agency_search"
				hide-default-footer
				:footer-props="footer_options"
				:items-per-page="-1"
				class="k-admin-users-table"
			>
				<template v-slot:item="{ item }"><tr v-show="parent_showing(item)" :class="`k-agency-table-row-${item.agency_type}`">
					<td class="">{{item.agency_id}}</td>
					<td class="">{{item.sourced_id}}</td>
					<td class="">{{item.agency_type}}</td>
					<td>
						<k-btn v-if="item.parent_id" icon small class="mr-2" accessible-label="Edit agency name" @click="edit_agency(item, 'agency_name', 'agency name')"><k-icon small>fas fa-edit</k-icon></k-btn>
						<span v-if="item.agency_type=='school'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<span v-html="item.agency_name"></span>
						<k-btn v-if="item.agency_type=='district'" x-small text class="ml-0" @click="item.children_showing=!item.children_showing">{{item.children_showing?'Hide':'Show'}} Schools</k-btn>
					</td>
					<td class="">
						<k-btn v-if="item.parent_id" icon small class="mr-2" accessible-label="Edit agency admin email" @click="edit_agency(item, 'agency_admin_email', `agency admin (email)`)"><k-icon small>fas fa-edit</k-icon></k-btn>
						{{item.agency_admin_email_display}}
					</td>
					<td class="">
						<!-- currently allow subdomains on districts only -->
						<k-btn v-if="item.agency_type=='district'" icon small class="mr-2" accessible-label="Edit agency subdomain" @click="edit_agency(item, 'subdomain', `${site_config.app_name} subdomain`)"><k-icon small>fas fa-edit</k-icon></k-btn>
						{{item.subdomain_display}}
					</td>
					<td class="">{{item.parent_id}}</td>
					<td class="">
						<k-tooltip bottom><template v-slot:activator="{on}">
							<k-btn v-on="on" v-visible="item.agency_type!='school'" icon small class="" color="green darken-3" accessible-label="Add child agency" @click="create_agency(item)"><k-icon small>fas fa-plus-circle</k-icon></k-btn>
						</template>Add child agency</k-tooltip>
						<k-tooltip bottom><template v-slot:activator="{on}">
							<k-btn v-on="on" v-visible="item.parent_id" icon small class="ml-2" color="red darken-3" accessible-label="Delete agency" @click="delete_agency(item)"><k-icon small>fas fa-trash-alt</k-icon></k-btn>
						</template>Delete this agency</k-tooltip>
					</td>
				</tr></template>
			</k-data-table>
		</div>
	</div>


	<div v-show="mode=='lti'">
		<div class="d-flex align-center mb-3">
			<h3>{{site_config.sparkl_app_name}} LTI Installations</h3>

			<k-spacer/>

			<div class="mr-2">LTI types:</div>
			<k-btn-toggle dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" mandatory
				v-model="lti_type_showing"
			>
				<k-btn small light value="all">  All  </k-btn>
				<k-btn small light value="lti_1_1">  LTI 1.1  </k-btn>
				<k-btn small light value="lti_1_3">  LTI 1.3  </k-btn>
				<k-btn small light class="k-tight-btn" value="gc_addon">GC Add-on</k-btn>
			</k-btn-toggle>

			<k-spacer/>

			<div><k-btn @click="load_lti_organization_list">Load / Reload LTI Installation List</k-btn></div>
		</div>

		<div v-if="lti_organizations" style="clear:both">
			<div class="py-4 d-flex">
				<k-text-field
					v-model="lti_search"
					prepend-inner-icon="fa fa-search" clearable clear-icon="fa fa-times-circle"
					prepend-decorative
					aria-label="Search LTI installations"
					label="Search" single-line hide-details outlined dense background-color="#fff" style="flex:0 1 450px"
				></k-text-field>
				<k-btn class="ml-8" color="primary" @click="create_org"><k-icon small class="mr-2">fas fa-plus</k-icon> Add New LTI Installation</k-btn>
			</div>

			<k-data-table light
				:headers="lti_headers"
				:items="lti_organizations"
				xsort-by="['su','user']"
				xsort-desc="[true,false]"
				xmust-sort="true"
				:custom-filter="table_lti_search_filter"
				:search="lti_search"
				hide-default-footer
				:footer-props="footer_options"
				:items-per-page="-1"
				class="k-admin-users-table"
			>
				<template v-slot:item="{ item }">
					<tr v-if="lti_type_showing=='all' || lti_type_showing==item.lti_type">
						<td>
							<k-btn icon small class="mr-2" accessible-label="Edit organization name" @click="edit_lti_org(item, 'organization_name', 'Organization Name')"><k-icon small>fas fa-edit</k-icon></k-btn>
							<span v-html="item.organization_name"></span>
						</td>
						<td>
							<div v-if="item.lti_type=='lti_1_1'">LTI 1.1</div>
							<div v-if="item.lti_type=='lti_1_3'">LTI 1.3</div>
							<div v-if="item.lti_type=='gc_addon'">GC Add-on</div>
						</td>
						<td>
							<div class="d-flex align-center">
								<k-btn icon small class="mr-2" 
									v-if="item.lti_type=='lti_1_1'"
									accessible-label="Edit organization key" 
									@click="edit_lti_org(item, 'key_key', 'Organization Key')"
								><k-icon small>fas fa-edit</k-icon></k-btn>

								<div>{{item.key_key}}</div>

								<div v-if="item.lti_type=='lti_1_1'" class="d-flex align-center">
									<span class="ml-5 mr-2">Secret:</span>

									<span style="font-size:10px">⏺⏺⏺⏺⏺⏺⏺⏺</span>

									<k-btn class="ml-1" icon small color="primary" 
										accessible-label="Copy organization secret" 
										@click="copy_secret(item)"
									><k-icon small>fas fa-clipboard</k-icon></k-btn>

									<k-btn icon small class="ml-0" 
										accessible-label="Regenerate organization secret" 
										@click="edit_lti_org(item, 'secret', 'Secret')"
									><k-icon small>fas fa-arrows-rotate</k-icon></k-btn>

								</div>
							</div>
						</td>
						<td class="text-center"><nobr>{{item.created_at.substr(0,10)}}</nobr></td>
						<td class="text-center"><nobr>{{item.login_at ? item.login_at.substr(0,10) : '–'}}</nobr></td>
						<td class="text-center">{{item.login_count}}</td>
						<td class="text-center"><k-btn icon small class="ml-2" color="red" accessible-label="Delete LTI installation" @click="delete_org(item)"><k-icon small>fas fa-trash-alt</k-icon></k-btn></td>
					</tr>
				</template>
			</k-data-table>
		</div>
		<div v-else class="mt-12 mb-3"><i>This area allows you to manage LTI installations for {{site_config.sparkl_app_name}}. To get started, click the “LOAD / RELOAD LTI INSTALLATION LIST” button above.</i></div>
	</div>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
// import AdminUserEdit from './AdminUserEdit'

export default {
	components: { },
	props: {
	},
	data() { return {
		// TODO: allow to hide either of the modes...

		// mode: 'agencies',
		mode: 'lti',

		agencies: null,
		agency_headers: [
			{ text: 'ID', align: 'left', sortable: false, value:'agency_id' },
			{ text: 'Sourced ID', align: 'left', sortable: false, value:'sourced_id' },
			{ text: 'Type', align: 'left', sortable: false, value:'agency_type' },
			{ text: 'Agency Name', align: 'left', sortable: false, value:'agency_name' },
			{ text: 'Agency Admin', align: 'left', sortable: false, value:'agency_admin_email' },
			{ text: 'Subdomain', align: 'left', sortable: false, value:'subdomain' },
			{ text: 'Parent ID', align: 'left', sortable: false, value:'parent_id' },
			{ text: '', sortable: false },	// for delete btn
		],
		footer_options: {
			itemsPerPageOptions: [10,50,100,-1],
		},
		agency_search: '',

		lti_organizations: null,
		lti_headers: [
			{ text: 'Organization Name', align: 'left', sortable: true, value:'organization_name' },
			{ text: 'Type', align: 'center', sortable: true, value:'lti_type' },
			{ text: 'Credentials', align: 'left', sortable: true, value:'key_key' },
			{ text: 'Created', align: 'center', sortable: true, value:'created_at' },
			{ text: 'Last LTI Login', align: 'center', sortable: true, value:'login_at' },
			{ text: 'LTI Login Ct', align: 'center', sortable: true, value:'login_count' },
			{ text: '', sortable: false },	// for delete btn
		],
		footer_options: {
			itemsPerPageOptions: [10,50,100,-1],
		},
		lti_search: '',
	}},
	computed: {
		...mapState(['user_info', 'all_courses_loaded', 'all_courses', 'site_config']),
		lti_admin_enabled() { return this.site_config.enable_admin_lti_management == 'yes' },
		subdomain_admin_enabled() { return this.site_config.enable_subdomains == 'yes' },
		both_modes_enabled() { return this.lti_admin_enabled && this.subdomain_admin_enabled },
		lti_type_showing: {
			get() { return this.$store.state.lst.admin_lti_type_showing },
			set(val) { this.$store.commit('lst_set', ['admin_lti_type_showing', val]) }
		},
	},
	created() {
		// DEBUG
		vapp.admin_lti_component = this

		// if only one of the two modes is enabled for this cureum, set to the other one
		// (if neither mode is enabled, we won't even be able to get to this tool)
		if (!this.lti_admin_enabled) this.mode = 'agencies'
		else if (!this.subdomain_admin_enabled) this.mode = 'lti'
	},
	mounted() {
	},
	methods: {
		load_agency_list() {
			let payload = {
				user_id: this.user_info.user_id,
			}
			U.loading_start()
			U.ajax('admin_manage_agencies', payload, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					this.$alert('Error in admin ajax call: ' + result.status); vapp.ping(); return;
				}

				this.process_agencies(result.agencies)
			});
		},

		// process agency data retrieved from DB
		process_agencies(arr) {
			let domain = window.location.host
			if (domain.includes('localhost')) domain = 'cureum.org'

			let districts = []
			for (let a of arr) {
				// get parent IDs (assume only one, at least for now)
				for (let p of arr) {
					if (p.child_agency_ids && p.child_agency_ids.includes(a.agency_id)) {
						a.parent_id = p.agency_id
						a.parent_agency = p
					}
				}

				// create string for search purposes
				a.id_string = `${a.agency_id} ${a.sourced_id}`

				if (empty(a.sort_val)) a.sort_val = a.agency_name
				if (empty(a.sourced_id)) a.sourced_id = '–'

				// handle subdomains
				if (empty(a.subdomain)) {
					a.subdomain = ''
					if (empty(a.parent_id)) a.subdomain_display = domain
					else a.subdomain_display = '–'
				} else {
					a.subdomain_display = `${domain}/sd/${a.subdomain}`
				}

				// handle admins
				if (empty(a.agency_admin_email)) {
					a.agency_admin_email = ''
					a.agency_admin_email_display = '–'
				} else {
					a.agency_admin_email_display = a.agency_admin_email
				}

				if (a.agency_type == 'district') {
					districts.push(a)
				}

				// transfer previous value of children_showing if we have one
				let old_agency = this.agencies?.find(x=>x.agency_id == a.agency_id)
				if (old_agency) a.children_showing = old_agency.children_showing
				else a.children_showing = false
			}

			// sort districts by name
			districts.sort((a,b)=>{return U.natural_sort(a.agency_name, b.agency_name)})

			// create sort_vals
			for (let a of arr) {
				if (a.agency_type == 'state') a.sort_val = ''
				else if (a.agency_type == 'district') a.sort_val = districts.findIndex(x=>x==a) + ''
				// note that we assume all parents appear before the parent's children in the incoming data
				else a.sort_val = `${a.parent_agency.sort_val}--${a.agency_name}`
			}

			// this makes sure schools are under their districts, but doesn't sort alphabetically
			arr.sort((a,b)=>{return U.natural_sort(a.sort_val, b.sort_val)})
			console.log(object_copy(arr))
			this.agencies = arr
		},

		parent_showing(agency) {
			// always show state and district
			if (agency.agency_type != 'school') return true
			// show school if the school's parent has children_showing: true
			return agency.parent_agency.children_showing
		},

		table_agency_search_filter(value, agency_search, item) {
			// value is the value of the column (we can ignore this); agency_search is the agency_search string (could be empty)
			// RETURN FALSE TO HIDE THE ITEM

			// if agency_search is empty, always return true, so the row will SHOW
			if (empty(agency_search)) return true

			agency_search = agency_search.toLowerCase()
			let re = new RegExp(agency_search, 'i')

			// check agency name and id_string
			if (item.agency_name.search(re) > -1) return true
			if (item.id_string.search(re) > -1) return true
			if (item.subdomain_display.search(re) > -1) return true

			// if we get to here return false
			return false
		},

		async create_agency(parent_agency) {
			let type_to_create
			if (parent_agency.agency_type == 'state') type_to_create = 'district'
			else if (parent_agency.agency_type == 'district') type_to_create = 'school'
			else return	// for now we only support 3 levels

			let agency_name, sourced_id
			try {
				agency_name = await this.$prompt({
					title: 'Create New Agency: Agency Name',
					text: `Enter the Agency Name for the new <b>${type_to_create}</b> that is to be a child of <b>“${parent_agency.agency_name}”</b>:`,
					disableForEmptyValue: true,
					acceptText: 'Next',
					acceptIconAfter: 'fas fa-circle-arrow-right',
					dialogMaxWidth: 600,
				})
			} catch(e) { return }
			agency_name = $.trim(agency_name)
			if (empty(agency_name)) return
			// agency_name doesn't have to be unique (there could be multiple schools for the same district

			try {
				sourced_id = await this.$prompt({
					title: 'Create New Agency: Sourced ID',
					text: `Enter the “Sourced ID” for the new ${type_to_create}:`,
					disableForEmptyValue: true,
					acceptText: 'Next',
					acceptIconAfter: 'fas fa-circle-arrow-right',
					dialogMaxWidth: 600,
				})
			} catch(e) { return }
			sourced_id = $.trim(sourced_id)
			if (empty(sourced_id)) return
			// make sure sourced_id is unique
			let other_agency = this.agencies.find(x=>x.sourced_id == sourced_id)
			if (other_agency) {
				this.$alert(`The Sourced ID you entered (${sourced_id}) is already in use by another agency (“${other_agency.agency_name}”). Each Sourced ID must be unique.`)
			}

			let payload = {
				parent_agency_id: parent_agency.agency_id,
				agency_type: type_to_create,
				agency_name: agency_name,
				sourced_id: sourced_id
			}
			console.warn(payload)
			this.submit_agency_crud(payload, `Agency created`, 'Are you sure you want to create this new agency?')
		},

		edit_agency(agency, key, key_title) {
			let text = ''
			text += `Enter new value for <b>${key_title}</b>:`
			this.$prompt({
				title: 'Update Agency',
				text: text,
				dialogMaxWidth: 600,
				initialValue: agency[key],
				acceptText: 'Update',
			}).then(val => {
				val = $.trim(val)
				if (empty(val)) return

				// make sure val doesn't match any other agency (but not for the admin)
				if (key != 'agency_admin_email') {
					let other_agency = this.agencies.find(x=>x[key] == val && x.agency_id != agency.agency_id)
					if (other_agency) {
						this.$alert(`Another agency (${other_agency.agency_name}) already has that ${key}.`)
						return
					}
				}

				if (val != agency[key]) {
					let updated_agency = {agency_id: agency.agency_id}
					updated_agency[key] = val

					let reconfirm_msg = (key == 'key_key') ? `Are you ABSOLUTELY SURE you want to update the LTI key for ${agency.agency_name}? THIS IS NOT UNDOABLE!` : ''
					this.submit_agency_crud(updated_agency, `${key_title} updated`, reconfirm_msg)
				}
			})
		},

		delete_agency(agency) {
			this.$confirm({
				title: 'Are you sure?',
				text: `Are you sure you want to delete agency ${agency.agency_name}?`,
				acceptText: 'Delete Agency',
				acceptColor: 'red',
				dialogMaxWidth: 600,
			}).then(y => {
				this.submit_agency_crud({agency_id: agency.agency_id, delete: 'delete'}, `Agency “${agency.agency_name}” deleted`, `Are you ABSOLUTELY SURE you want to delete the agency “${agency.agency_name}”? THIS IS NOT UNDOABLE!`)
			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		submit_agency_crud(updated_agency, inform_msg, reconfirm_msg) {
			if (reconfirm_msg) {
				this.$confirm({
					title: 'Re-Confirm',
					text: reconfirm_msg,
					acceptText: 'Proceed',
					acceptColor: 'red',
					dialogMaxWidth: 600,
				}).then(y => {
					this.submit_agency_crud(updated_agency, inform_msg)
				}).catch(n=>{console.log(n)}).finally(f=>{})
				return
			}

			let payload = {
				user_id: this.user_info.user_id,
				updated_agency: U.encode_blocked_keywords(JSON.stringify(updated_agency)),
				encode_blocked_keywords: ['updated_agency'],
			}
			// console.warn(payload); return

			// admin_manage_lti_organizations serves both to retrieve list of organizations and handle CRUD operations
			U.loading_start()
			U.ajax('admin_manage_agencies', payload, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					this.$alert('Error in admin ajax call: ' + result.status); vapp.ping(); return;
				}

				this.$inform(inform_msg)

				this.process_agencies(result.agencies)
			});
		},

		/////////////////////////////////////////////////////
		load_lti_organization_list() {
			let payload = {
				user_id: this.user_info.user_id,
			}
			U.loading_start()
			U.ajax('admin_manage_lti_organizations', payload, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					this.$alert('Error in admin ajax call: ' + result.status); vapp.ping(); return;
				}

				this.process_orgs(result.organizations)
			});
		},

		process_orgs(orgs) {
			let arr = []
			for (let org of orgs) {
				// determine lti_type
				if (org.key_key.search(/^GC-/) == 0) {
					org.lti_type = 'gc_addon'
				} else if (org.secret == 'lti_v1.3') {
					org.lti_type = 'lti_1_3'
				} else {
					org.lti_type = 'lti_1_1'
				}

				arr.push(org)
			}
			this.lti_organizations = arr
		},

		table_lti_search_filter(value, lti_search, item) {
			// value is the value of the column (we can ignore this); lti_search is the lti_search string (could be empty)
			// RETURN FALSE TO HIDE THE ITEM

			// if lti_search is empty, always return true, so the row will SHOW
			if (empty(lti_search)) return true

			lti_search = lti_search.toLowerCase()
			let re = new RegExp(lti_search, 'i')

			// check org name and key
			if (item.organization_name.search(re) > -1) return true
			if (item.key_key.search(re) > -1) return true

			// if we get to here return false
			return false
		},

		edit_lti_org(org, key, key_title) {
			if (key == 'secret') {
				this.$confirm({
					title: 'Generate New LTI Secret',
					text: 'Are you sure you want to generate a new secret for this LTI installation? <b class="red--text text--darken-2">If you do this, LTI links for the installation will cease to work until the organization updates their installation with the new secret.</b>',
					acceptText: 'Generate New Secret',
					dialogMaxWidth: 600,
					focusBtn: true,		// focus on the accept btn when dialog is rendered
				}).then(y => {
					let updated_org = {organization_id: org.organization_id}
					updated_org.secret = U.new_uuid()
					this.submit_org_crud(updated_org, 'Secret updated', `Are you ABSOLUTELY SURE you want to generate a new secret for ${org.organization_name}? THIS IS NOT UNDOABLE!`)
				}).catch(n=>{console.log(n)}).finally(f=>{})

			} else {
				let text = ''
				if (key == 'key_key') text += '<div class="mb-2">Are you sure you want to update the LTI key for this LTI installation? <b class="red--text text--darken-2">If you do this, LTI links for the installation will cease to work until the organization updates their installation with the new key.</b></div>'
				text += `Enter new value for ${key_title}:`
				this.$prompt({
					title: 'Update LTI Installation',
					text: text,
					dialogMaxWidth: 600,
					initialValue: org[key],
					acceptText: 'Update',
				}).then(val => {
					val = $.trim(val)
					if (empty(val)) return

					// make sure val doesn't match any other organization
					let other_org = this.lti_organizations.find(x=>x[key] == val && x.organization_id != org.organization_id)
					if (other_org) {
						this.$alert(`Another LTI installation (${other_org.organization_name}) already has that ${key}.`)
						return
					}

					if (val != org[key]) {
						let updated_org = {organization_id: org.organization_id}
						updated_org[key] = val

						let reconfirm_msg = (key == 'key_key') ? `Are you ABSOLUTELY SURE you want to update the LTI key for ${org.organization_name}? THIS IS NOT UNDOABLE!` : ''
						this.submit_org_crud(updated_org, `${key_title} updated`, reconfirm_msg)
					}
				})
			}
		},

		create_org() {
			this.$prompt({
				title: 'Create New LTI Installation',
				text: 'Enter organization name for LTI Installation (e.g. “Bartow County”):',
				initialValue: '',
				disableForEmptyValue: true,
				acceptText: 'Next',
				acceptIconAfter: 'fas fa-arrow-right',
			}).then(organization_name => {
				organization_name = $.trim(organization_name)
				if (empty(organization_name)) return

				// make sure val doesn't match any other organization
				let other_org = this.lti_organizations.find(x=>x.organization_name == organization_name)
				if (other_org) {
					this.$alert(`An LTI installation with that name (${organization_name}) already exists.`)
					return
				}

				this.$prompt({
					title: 'Create New LTI Installation',
					text: 'Enter organization “key” for LTI Installation (e.g. “bartow.k12.ga.us”):',
					initialValue: '',
					disableForEmptyValue: true,
					acceptText: 'Create',
					acceptIconAfter: 'fas fa-arrow-right',
				}).then(key_key => {
					key_key = $.trim(key_key)
					if (empty(key_key)) return

					// make sure val doesn't match any other organization
					let other_org = this.lti_organizations.find(x=>x.key_key == key_key)
					if (other_org) {
						this.$alert(`Another LTI installation (${other_org.organization_name}) is already using that key (${key_key}).`)
						return
					}

					this.submit_org_crud({organization_name: organization_name, key_key: key_key, secret: U.new_uuid()}, `LTI installation for ${organization_name} created`)

				}).catch(n=>{console.log(n)}).finally(f=>{})
			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		delete_org(org) {
			this.$confirm({
				title: 'Are you sure?',
				text: 'Are you sure you want to delete this LTI installation? <b class="red--text text--darken-2">If you proceed, any LTI links created for this installation will cease to work.</b>',
				acceptText: 'Delete LTI Installation',
				acceptColor: 'red',
				dialogMaxWidth: 600,
			}).then(y => {
				this.submit_org_crud({organization_id: org.organization_id, delete: 'delete'}, `LTI installation for ${org.organization_name} deleted`, `Are you ABSOLUTELY SURE you want to delete the LTI installation for ${org.organization_name}? THIS IS NOT UNDOABLE!`)
			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		submit_org_crud(updated_org, inform_msg, reconfirm_msg) {
			if (reconfirm_msg) {
				this.$confirm({
					title: 'Re-Confirm',
					text: reconfirm_msg,
					acceptText: 'Proceed',
					acceptColor: 'red',
					dialogMaxWidth: 600,
				}).then(y => {
					this.submit_org_crud(updated_org, inform_msg)
				}).catch(n=>{console.log(n)}).finally(f=>{})
				return
			}

			let payload = {
				user_id: this.user_info.user_id,
				updated_org: updated_org
			}
			// admin_manage_lti_organizations serves both to retrieve list of organizations and handle CRUD operations
			U.loading_start()
			U.ajax('admin_manage_lti_organizations', payload, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					this.$alert('Error in admin ajax call: ' + result.status); vapp.ping(); return;
				}

				this.$inform(inform_msg)

				this.lti_organizations = result.lti_organizations
			});
		},

		copy_secret(org) {
			U.copy_to_clipboard(`KEY: ${org.key_key} \nSECRET: ${org.secret}\n`)
			this.$inform('Key and secret copied to clipboard')
		},

		return_to_admin_main() {
			this.$router.push({ path: '/' })
		},
	}
}
</script>

<style lang="scss">
.k-agency-table-row-state {background-color:$v-yellow-lighten-5;}
.k-agency-table-row-district {background-color:$v-teal-lighten-5;}
.k-agency-table-row-school {background-color:$v-deep-purple-lighten-5;}
</style>
